import { formatToolDisplayName } from 'src/data/generationTool';

export const generateToolListTooltip = (toolList) =>
  toolList.reduce(
    (accumulator, currentValue) =>
      accumulator + formatToolDisplayName(currentValue, { useTitle: true }) + '\n',
    ''
  );
